import script from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"

import "./AdminMenu.vue?vue&type=style&index=0&id=e4d94564&lang=scss"

const __exports__ = script;

export default __exports__